// i18n.ts
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
// Import JSON translation files
import translationEN from './locales/en/translation.json';
import translationFR from './locales/fr/translation.json';
import translationES from './locales/es/translation.json';
const resources = {
    en: { translation: translationEN },
    fr: { translation: translationFR },
    es: { translation: translationES },
};
i18n
    .use(LanguageDetector) // Enables auto language detection
    .use(initReactI18next) // Connects with react-i18next
    .init({
    resources,
    fallbackLng: 'en', // Fallback language
    interpolation: {
        escapeValue: false, // React already escapes content
    },
    detection: {
        order: ['navigator', 'htmlTag', 'path', 'subdomain'],
        caches: ['localStorage', 'cookie'],
    },
});
export default i18n;
